import React, {Component} from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {Alert, AlertWarning} from '@homeaway/react-alerts';
import {INFO__24} from '@homeaway/svg-defs';
import {SMALL, MEDIUM} from '../helpers/IconSize';
import IconTypes from '../helpers/IconTypes';
import {buildMessage, getIconProps} from '../helpers/helpers';


import './BaseUrgencyMessage.less';
const NEW_LINE_PLACEHOLDER = '{NEW_LINE_PLACEHOLDER}';

export default class BaseUrgencyMessage extends Component {
    static defaultProps = {
        className: '',
        size: MEDIUM,
        unitMessage: {},
        color: false,
        ariaHidden: false
    };
    static contextType = TrackingContext;

    BASE_CLASS = 'UrgencyUnitMessage';

    generateAlertComponent(componentGenerationParams) {
        const {icon} = componentGenerationParams;
        const urgencyComponent = this.generateUrgencyComponent(componentGenerationParams);
        // eslint-disable-next-line eqeqeq
        if (icon === IconTypes.INFO) {
            return (
                <Alert
                    msg={urgencyComponent}
                    flairClassName="bg--accent-orange-light"
                    svgClassName="text--accent-orange-light"
                    svgMarkup={INFO__24}
                    subtle
                />
            );
        }

        if (icon === IconTypes.WARN) {
            return (
                <AlertWarning msg={urgencyComponent}/>
            );
        }

        return urgencyComponent;
    }

    generateUrgencyComponent(componentGenerationParams) {
        const {baseClass, className, ariaHidden, src, size, icon, title, message, link, smallPrefix, isNewLine, style} = componentGenerationParams;
        return (
            <div className={`${baseClass} ${className}`} aria-hidden={ariaHidden}>
                {
                    src &&
                    <div className={`${baseClass}__img--${size}`}>
                        <img style={style} src={src} alt={icon} />
                    </div>
                }
                <div className={`${baseClass}__message${smallPrefix}`}>
                    {
                        title &&
                        <span className={`${baseClass}__message${smallPrefix}__title`}><strong>{title}</strong></span>
                    }
                    {
                        isNewLine && <br/>
                    }
                    <span className={`${baseClass}__message${smallPrefix}__text`}>
                        {buildMessage(message, link, `${baseClass}__link`)}
                    </span>
                </div>
            </div>
        );
    }

    generateComponent = ({baseClass, className, size, color, ariaHidden}, urgencyMessageContent) => {
        const {icon, message, link} = urgencyMessageContent;
        if (!message) {
            return null;
        }
        let {title} = urgencyMessageContent;
        let isNewLine = false;
        const smallPrefix = size === SMALL ? '--s' : '';
        if (title && title.includes(NEW_LINE_PLACEHOLDER)) {
            title = title.replace(NEW_LINE_PLACEHOLDER, '');

            isNewLine = true;
        }
        let componentGenerationParams = {baseClass, className, size, ariaHidden, isNewLine, icon, message, link, title, smallPrefix};

        if (icon === IconTypes.INFO || icon === IconTypes.WARN) {
            delete componentGenerationParams.className;
            return this.generateAlertComponent(componentGenerationParams);
        }

        const {style, src} = getIconProps(icon, size, color);

        componentGenerationParams = {style, src, ...componentGenerationParams};
        return this.generateUrgencyComponent(componentGenerationParams);
    };
}
